<div class="pb-9">
  @if (showLevel1 && !showShopMenu) {
    <button class="link-button" (click)="goToPage('/')">
      {{ 'common.homepage' | cxTranslate }}
    </button>
  }

  <!-- Main navigation  -->
  @if (!showShopMenu) {
    <div *ngFor="let item of navigationNodes; first as isFirst; last as isLast; let i = index">
      <div *ngIf="showLevel1">
        <button
          [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + item?.fields?.name + '-' + i"
          (click)="toggleLevel1(item, i)"
          class="bg-transparent border-0 p-0 w-100"
          *ngIf="showLevel1"
        >
          <div class="d-flex justify-content-between">
            <div
              class="name"
              [ngClass]="{ 'shop-item': item.fields?.name?.trim()?.toLowerCase() === 'shop' }"
            >
              {{ item.fields?.name | removeDollarSign }}
            </div>
            <div><app-svg dimension="1.50rem" iconName="ArrowSmall" [rotate]="180"></app-svg></div>
          </div>
        </button>

        <hr class="my-6" />

        @if (isLast) {
          <ng-container *ngTemplateOutlet="contactsSection"></ng-container>
        }
      </div>

      <div *ngIf="item?.fields?.childNavigationNodes?.length > 0 && toggle[i]">
        <div
          *ngFor="
            let subNavItem of item?.fields?.childNavigationNodes;
            first as isFirst2;
            let i2 = index
          "
        >
          <div *ngIf="isFirst2 && showLevel2">
            <a
              (click)="toggle[i] = !toggle[i]; showLevel1 = true"
              class="back-link"
              style="margin-left: -14px"
            >
              <app-svg iconName="ArrowSmall" dimension="1.25rem"></app-svg>
              <span class="back-button">{{ 'common.back' | cxTranslate }}</span>
            </a>
            <div class="name mb-3">
              {{ item.fields?.name | removeDollarSign }}
            </div>
            <button class="link-button" (click)="goToPage(item.fields?.url)">
              {{ 'common.overviewPage' | cxTranslate }}
            </button>
          </div>

          <div *ngIf="showLevel2 && subNavItem?.fields?.name">
            <ng-container
              *ngIf="!subNavItem?.fields?.childNavigationNodes && subNavItem?.fields.url"
            >
              <button
                [attr.data-qa]="
                  headerNavigationLink?.getButtonId() + '-' + subNavItem?.fields?.name + '-' + i
                "
                class="bg-transparent border-0 p-0 w-100"
                [routerLink]="subNavItem?.fields?.url"
                (click)="closeNavigation()"
              >
                <div class="d-flex justify-content-between">
                  <div
                    class="name"
                    [ngClass]="{
                      navHighlight: subNavItem?.fields?.name.includes('$'),
                      more: subNavItem.fields?.name?.trim()?.toLowerCase()?.includes('weitere'),
                    }"
                  >
                    {{ subNavItem?.fields?.name | removeDollarSign }}
                  </div>
                </div>
              </button>
            </ng-container>

            <ng-container *ngIf="subNavItem?.fields?.childNavigationNodes">
              <button
                [attr.data-qa]="
                  headerNavigationLink?.getButtonId() + '-' + subNavItem?.fields?.name + '-' + i
                "
                class="mulish-semiBold bg-transparent border-0 p-0 w-100"
                (click)="toggleLevel2(subNavItem, i, i2)"
              >
                <div class="d-flex justify-content-between">
                  <div
                    class="name"
                    [ngClass]="{
                      navHighlight: subNavItem?.fields?.name.includes('$'),
                      more: subNavItem.fields?.name?.trim()?.toLowerCase()?.includes('weitere'),
                    }"
                  >
                    {{ subNavItem?.fields?.name | removeDollarSign }}
                  </div>
                  <div>
                    <app-svg dimension="1.25rem" iconName="ArrowSmall" [rotate]="180"></app-svg>
                  </div>
                </div>
              </button>
            </ng-container>

            <hr class="my-6" />
          </div>

          <div *ngIf="subNavItem?.fields?.childNavigationNodes && toggle[i + '.' + i2]">
            <div
              *ngFor="
                let subNavItem1 of subNavItem?.fields?.childNavigationNodes;
                first as isFirst3;
                let i3 = index
              "
            >
              <div *ngIf="isFirst3">
                <a
                  (click)="toggle[i + '.' + i2] = !toggle[i + '.' + i2]; showLevel2 = true"
                  class="back-link"
                  style="margin-left: -14px"
                >
                  <app-svg iconName="ArrowSmall" dimension="1.25rem"></app-svg>
                  <span class="back-button">{{ 'common.back' | cxTranslate }}</span>
                </a>
                <div class="name mb-3">
                  {{ subNavItem.fields?.name | removeDollarSign }}
                </div>
                <button class="link-button" (click)="goToPage(subNavItem.fields?.url)">
                  {{ 'common.overviewPage' | cxTranslate }}
                </button>
              </div>

              @if (subNavItem1?.fields?.name) {
                <button
                  [attr.data-qa]="
                    headerNavigationLink?.getButtonId() + '-' + subNavItem1?.fields?.name + '-' + i
                  "
                  class="bg-transparent border-0 p-0 w-100"
                  [routerLink]="subNavItem1?.fields?.url"
                  (click)="closeNavigation()"
                  [ngClass]="{
                    'more mb-7': subNavItem1?.fields?.name
                      ?.trim()
                      ?.toLowerCase()
                      ?.includes('weitere'),
                  }"
                >
                  <div class="d-flex justify-content-between">
                    <div class="name">{{ subNavItem1?.fields?.name }}</div>
                  </div>
                </button>

                <hr
                  *ngIf="!subNavItem1?.fields?.name?.trim()?.toLowerCase()?.includes('weitere')"
                  class="my-6"
                />
              }
            </div>

            <ng-container *ngTemplateOutlet="contactsSection"></ng-container>
            <ng-container
              *ngTemplateOutlet="nodeImage; context: { $implicit: subNavItem }"
            ></ng-container>
          </div>
        </div>

        @if (showLevel2) {
          <ng-container *ngTemplateOutlet="contactsSection"></ng-container>
          <ng-container *ngTemplateOutlet="nodeImage; context: { $implicit: item }"></ng-container>
        }
      </div>
    </div>
  }

  <!-- Shop navigation  -->
  @if (showShopMenu && !currentCategory) {
    <a (click)="showShopMenu = false" class="back-link" style="margin-left: -14px">
      <app-svg iconName="ArrowSmall" dimension="1.25rem"></app-svg>
      <span class="back-button">{{ 'common.mainNavigation' | cxTranslate }}</span>
    </a>
  }

  @if (showShopMenu && currentCategory && !parent) {
    <a (click)="showAllShopCategories()" class="back-link" style="margin-left: -14px">
      <app-svg iconName="ArrowSmall" dimension="1.25rem"></app-svg>
      <span class="back-button">{{ 'Alle Shop Kategorien' }}</span>
    </a>
  }

  @if (showShopMenu && currentCategory && parent) {
    <a (click)="openCategory(parent.code)" class="back-link" style="margin-left: -14px">
      <app-svg iconName="ArrowSmall" dimension="1.25rem"></app-svg>
      <span class="back-button">{{ parent.name }}</span>
    </a>
  }

  @if (showShopMenu) {
    <div class="name mb-3">
      {{ currentCategory?.name || 'Shop' }}
    </div>

    <button class="link-button" (click)="goToPage(currentCategory?.url || '/shop')">
      {{ (currentCategory?.url ? 'common.showAllProducts' : 'common.overviewPage') | cxTranslate }}
    </button>

    <div *ngFor="let category of categories; let i = index">
      <button
        [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + category.name + '-' + i"
        (click)="openCategory(category.code)"
        class="bg-transparent border-0 p-0 w-100"
        [class.disabled]="!category.count"
      >
        <div class="d-flex justify-content-between">
          <div class="name">
            {{ category.name }}
          </div>
          <div *ngIf="category.subcategories.length && category.count">
            <app-svg dimension="1.50rem" iconName="ArrowSmall" [rotate]="180"></app-svg>
          </div>
        </div>
      </button>

      <hr class="my-6" />
    </div>

    <ng-container *ngTemplateOutlet="contactsSection"></ng-container>
    <ng-container
      *ngTemplateOutlet="nodeImage; context: { $implicit: lvl1CategoryNode }"
    ></ng-container>
  }
</div>

<ng-template #contactsSection>
  <div *ngIf="!ociService.isOciSession" class="mulish-semiBold fs-14">
    <button
      class="mulish-semiBold bg-transparent border-0 p-0 w-100 mt-5 text-brand-grey mb-5"
      [routerLink]="['/s', 'beratung-service', 'kontakt']"
      (click)="closeNavigation()"
    >
      <div class="d-flex justify-content-between">
        {{ 'habaNavigation.topLinks.contact' | cxTranslate | uppercase }}
      </div>
    </button>
    <button
      class="mulish-semiBold bg-transparent border-0 p-0 w-100 mt-5 text-brand-grey mb-5"
      routerLinkActive="active"
      [routerLink]="['/s', 'direktbestellung']"
      (click)="closeNavigation()"
    >
      <div class="d-flex justify-content-between">
        {{ 'habaNavigation.topLinks.directOrders' | cxTranslate | uppercase }}
      </div>
    </button>

    <div style="margin-left: -6px">
      <app-top-links-country-selection [baseId]="baseId"></app-top-links-country-selection>
    </div>
  </div>
</ng-template>

<ng-template #nodeImage let-item>
  <div class="d-flex flex-column flyout-images">
    @if (
      item?.fields?.cloudinaryImage && item?.fields?.imageLinkUrl && item?.fields?.imageLinkText
    ) {
      <app-link [link]="item.fields.imageLinkUrl" [tabIndex]="1">
        <div class="d-flex flex-column image-container" (click)="closeNavigation()">
          <app-image
            [alt]="item.fields.imageTitle"
            [cloudinaryId]="item.fields.cloudinaryImage"
            [size]="imageSizes.HORIZONTAL_MENU_BANNER"
            class="no-fill"
          ></app-image>
          <div *ngIf="item.fields.imageTitle" class="banner-title">
            {{ item.fields.imageTitle }}
          </div>

          <div class="banner-link">{{ item.fields.imageLinkText }}</div>
        </div>
      </app-link>
    }

    @if (
      item?.fields?.cloudinaryImage2 && item?.fields?.image2LinkUrl && item?.fields?.image2LinkText
    ) {
      <app-link [link]="item.fields.image2LinkUrl" [tabIndex]="1">
        <div class="d-flex flex-column image-container" (click)="closeNavigation()">
          <app-image
            [alt]="item.fields.image2Title"
            [cloudinaryId]="item.fields.cloudinaryImage2"
            [size]="imageSizes.HORIZONTAL_MENU_BANNER"
            class="no-fill"
          ></app-image>
          <div *ngIf="item.fields.image2Title" class="banner-title">
            {{ item.fields.image2Title }}
          </div>

          <div class="banner-link">{{ item.fields.image2LinkText }}</div>
        </div>
      </app-link>
    }
  </div>
</ng-template>
